import Link from "next/link";
import Image from "next/image";
import logoImg from "@/public/logo-no-text.svg";

const footerLinks = {
  product: [
    { name: "Documentation", href: "/docs" },
    { name: "Changelog", href: "/changelog" },
    {
      name: "System Status",
      href: "https://status.uptime-monitor.io/6883a5c53de755cc0ebc41e8",
      external: true,
    },
    { name: "Blog", href: "https://blog.uptime-monitor.io", external: true },
  ],
  company: [
    { name: "Referral Program", href: "/referral-program" },
    { name: "Contact Support", href: "mailto:support@uptime-monitor.io" },
    { name: "FAQ", href: "/faq" },
  ],
  legal: [
    { name: "Terms of Service", href: "/tos" },
    { name: "Privacy Policy", href: "/privacy_policy" },
    { name: "Referral Terms", href: "/referral-terms" },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t bg-background">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand column */}
          <div className="space-y-4">
            <Link href="/" className="flex items-center gap-2">
              <Image
                width={32}
                height={32}
                className="h-8 w-8"
                src={logoImg}
                alt="Uptime Monitor"
              />
              <span className="font-semibold text-foreground">Uptime Monitor</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Reliable uptime monitoring for your websites and services.
            </p>
          </div>

          {/* Product column */}
          <div>
            <h3 className="text-sm font-semibold text-foreground">Product</h3>
            <ul className="mt-4 space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h3 className="text-sm font-semibold text-foreground">Company</h3>
            <ul className="mt-4 space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  {link.href.startsWith("mailto:") ? (
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal column */}
          <div>
            <h3 className="text-sm font-semibold text-foreground">Legal</h3>
            <ul className="mt-4 space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-8 border-t pt-8">
          <p className="text-sm text-muted-foreground text-center">
            &copy; {new Date().getFullYear()} Uptime Monitor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
